import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Button, Card, Container, Divider, Fab, FormControl, Grid, Stack, Table, TableBody, TableContainer, TableCell, TableHead, TablePagination, TableRow, TextField, Typography, Paper, MenuItem, Select } from '@mui/material';
import { KeyboardArrowLeftRounded, Add as AddIcon, ApprovalRounded } from '@mui/icons-material';
import { Link as RouterLink, Navigate, useParams } from 'react-router-dom';
import Scrollbar from '../components/scrollbar/Scrollbar';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import { right } from '@popperjs/core';
import { getAllIssue, updateIssue, userDetail, getInspectorList } from './qualityApi';
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom"
import { fDate } from '../../common/common-sidebar/utils/formatTime';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { BaseURL, authKey } from '../../common/URLs';
import { capitalizeFunction } from '../../common/commonValidations';
import { ApproveIcon, ReportIcon, SendIcon } from '../../common/icons';

function IssueATCReview() {
    const { action } = useParams();
    const navigate = useNavigate()

    function createData(issue, material, priority, alerts, invoice, createdOn, createdBy) {
        return { issue, material, priority, alerts, invoice, createdOn, createdBy };
    }

    const [issueDetails, getIssueDetails] = useState([]);
    const [updateReport, setAddReport] = useState();
    const [updateIssueById, getUpdateIssueById] = useState([])
    const [insDetails, getInsDetails] = useState([]);
    const [insName, setInsName] = useState('');
    const [insEmail, setInsEmail] = useState('');
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [Clarification, setClarification] = useState(false);

    useEffect(() => {

        userDetail(action).then((res) => {
            getIssueDetails(res);
            setInsName(res.qualityIssueDtlsEntity.inspectorName);
            setInsEmail(res.qualityIssueDtlsEntity.inspectorEmail);
            if (res && res.qualityIssueDtlsEntity.inspectorEmail) {
                setInsEmail(res.qualityIssueDtlsEntity.inspectorEmail);
            }
            // console.log(res, "lllo11")
            setSelectedFiles(res.qualityDocumentMasterEntity)
        }).catch((e) => {
            console.log(e);
        })

        getInspectorList().then((res) => {
            getInsDetails(res);
            console.log(res, "ins Details")
        }).catch((err) => {
            console.log(err);
        })

    }, [])


    const downloadDocument = (file, type) => {
        console.log("file", file)

        return fetch(BaseURL + '/document/v1/Blob/download_document'
            ,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    AuthKey: authKey,
                },
                body: JSON.stringify({
                    "fileName": file.documentBlobName,
                    "containerName": "qualityfiles",
                    "file": ""
                })
            })
            .then((response) => response.blob()
            )
            .then((blob) => {
                const fileName = file?.documentName
                const splittedName = fileName.split('.')
                const fileExtension = splittedName[splittedName.length - 1];
                let fileType;
                switch (fileExtension) {
                    case 'pdf':
                        fileType = 'application/pdf';
                        break;
                    case 'png':
                        fileType = 'image/png';
                        break;
                    case 'jpg':
                        fileType = 'image/jpeg';
                        break;
                    case 'jpeg':
                        fileType = 'image/jpeg';
                        break;
                    default:
                        fileType = 'application/octet-stream';
                }
                const url = window.URL.createObjectURL(new Blob([blob], { type: fileType }));
                const newWindow = window.open(url, '_blank');
                newWindow.focus();
                // loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                // loaderService.hideLoader()
            });
    }

    // const rows = issueDetails

    function updateReportHandler(e) {
        setAddReport(e.target.value);

        const result = e.target.value.replace(/[^\w\s\.\,]/gi, '')
        setAddReport(result)
    }

    const approveBtn = () => {
        if (updateReport == "") {
            toast.error("Please add review")
        } else {
            let getIssueById = {
                "qualityIssueDtlsEntity": {
                    "issueNumber": action,
                    "status": "Approved",
                    "reviewerComment": updateReport    
                },
                qualityDocumentMasterEntity:
                    selectedFiles
            }
            updateIssue(getIssueById, getUpdateIssueById).then((res) => {
                toast.success(res.description)
                navigate('../issueatc')
            })
        }
    }

    const rejectBtn = () => {
        if (updateReport == "") {
            toast.error("Please add review")
        } else {
            let getIssueById = {
                "qualityIssueDtlsEntity": {
                    "issueNumber": action,
                    "action": "Rejected",
                    "reviewerComment": updateReport,
                    "inspectorName": insName,
                    "inspectorEmail": insEmail,
                },
                qualityDocumentMasterEntity:
                    selectedFiles
            }
            updateIssue(getIssueById, getUpdateIssueById).then((res) => {
                toast.success(res.description)
                navigate('../issueatc')
            })
        }
    }

    const clarifyBtn = () => {
        if (updateReport == "") {
            toast.error("Please add review")
        } else {
            let getIssueById = {
                "qualityIssueDtlsEntity": {
                    "issueNumber": action,
                    "action": "Clarify",
                    "reviewerComment": updateReport,
                    "inspectorName": insName,
                    "inspectorEmail": insEmail,
                },
                qualityDocumentMasterEntity:
                    selectedFiles
            }
            updateIssue(getIssueById, getUpdateIssueById).then((res) => {
                toast.success("Please add review")
                setClarification(true);
                navigate('../issueatc')
            })
        }
    }

    function handleInspectorChange(e) {
        setInsName(e.target.value)
    }


    return (
        <>
            <Helmet>
                <title> Review & Approve ATC Report | ABEPL </title>
            </Helmet>
            <Container maxWidth="xl">
                <Typography variant="h4" sx={{ mb: 2 }}>
                    <Fab component={RouterLink} to='../issueatc' size="small" aria-label="back">
                        <KeyboardArrowLeftRounded />
                    </Fab> Review & Approve ATC Report
                </Typography>
                <Card>
                    <Stack spacing={2} sx={{ m: 2 }}>
                        <Grid container>
                            <Grid item md={3}>
                                <Card sx={{ p: 1, width: 'fit-content', }}>
                                    <Stack direction="row" spacing={2}>
                                        <Typography variant='subtitle2'>Issue Number</Typography>
                                        <Divider orientation="vertical" flexItem />
                                        <Typography variant='subtitle2'>{action}</Typography>
                                    </Stack>
                                </Card>
                            </Grid>
                        </Grid>

                        <Grid container>
                            <Grid item xs={12}>
                                <Card>
                                    <Scrollbar>
                                        <TableContainer component={Paper}>
                                            <Table sx={{ minWidth: 650 }} size="small" aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                    <TableCell> WorkOrderID</TableCell>
                                                        <TableCell align="center">Inspection Category</TableCell>
                                                        <TableCell align="center">New Recorded Quantity</TableCell>
                                                        <TableCell align="center">Material Code</TableCell>
                                                        <TableCell align="center">Inspector</TableCell>
                                                        <TableCell align="center">Bundle ID </TableCell>
                                                        <TableCell align="center" title="Deviation">Deviation</TableCell>
                                                        <TableCell align="center" title="Invoice Status">Invoice Status</TableCell>
                                                        <TableCell align="center">created On </TableCell>
                                                        <TableCell align="center">created By </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {/* {rows.map((row) => ( */}
                                                    <TableRow
                                                        key={issueDetails.qualityIssueDtlsEntity?.issueNumber}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell component="th" scope="row">
                                                            {issueDetails.qualityIssueDtlsEntity?.inspectionWorkOrderId}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {issueDetails.qualityIssueDtlsEntity?.inspectionCategory}
                                                        </TableCell>
                                                        <TableCell align="center">{issueDetails.qualityIssueDtlsEntity?.newQuantity || 'NA'}</TableCell>
                                                        <TableCell align="center">{issueDetails.qualityIssueDtlsEntity?.materialCode}</TableCell>
                                                        <TableCell align="center">
                                                            {issueDetails.qualityIssueDtlsEntity?.inspectorName}
                                                            <FormControl variant="standard" fullWidth>
                                                                {/* <InputLabel id="demo-simple-select-standard-label">Age</InputLabel> */}
                                                                <Select
                                                                    labelId="demo-simple-select-standard-label"
                                                                    id="demo-simple-select-standard"
                                                                    value={insName}
                                                                    label="Inspector Name"
                                                                    style={{ fontSize: "13px" }}
                                                                    onChange={handleInspectorChange}
                                                                >
                                                                    <MenuItem value="">Select</MenuItem>
                                                                    {
                                                                        insDetails.map(function (inspector, i) {
                                                                            return <MenuItem value={inspector.firstname + " " + inspector?.lastname ?? " "} key={inspector.id} style={{ fontSize: "14px" }}>
                                                                                {(inspector?.firstname + " " + inspector?.lastname).toUpperCase() || "Inspector Name"}
                                                                            </MenuItem>
                                                                        })
                                                                    }
                                                                </Select>
                                                            </FormControl>
                                                        </TableCell>
                                                        <TableCell align="center" style={{ width: '150px', fontSize: '12px' }}>{issueDetails.qualityIssueDtlsEntity?.lotNumber}</TableCell>
                                                        <TableCell align="center">{Number(issueDetails.qualityIssueDtlsEntity?.deviation).toFixed(2)}</TableCell>
                                                        <TableCell align="center">{issueDetails.qualityIssueDtlsEntity?.invoiceOnHoldTillQCClearance}</TableCell>
                                                        <TableCell align='center'>{fDate(issueDetails.qualityIssueDtlsEntity?.createdOn, 'dd/MM/yyyy')}</TableCell>
                                                        <TableCell align='center'>{issueDetails.qualityIssueDtlsEntity?.createdBy}</TableCell>
                                                    </TableRow>
                                                    {/* ))} */}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Scrollbar>
                                </Card>
                            </Grid>
                        </Grid>

                        <Grid container>
                            <Grid item xs={12}>
                                <Card>
                                    <Scrollbar>
                                        <TableContainer component={Paper}>
                                            <Table sx={{ minWidth: 650 }} size="small" aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>Quality Parameter</TableCell>
                                                        <TableCell align="center">Measurement location</TableCell>
                                                        <TableCell align="center">Measuring Instrument</TableCell>
                                                        <TableCell align="center">Actual Quantity</TableCell>
                                                        <TableCell align="center">Recoder Quantity</TableCell>
                                                        <TableCell align="center">Tolerance Limit</TableCell>
                                                        <TableCell align="center">Updated On</TableCell>
                                                        <TableCell align="center">Updated By </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {/* {rows.map((row) => ( */}
                                                    <TableRow
                                                        key={issueDetails.qualityIssueDtlsEntity?.issueNumber}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell component="th" scope="row">
                                                            {issueDetails.qualityIssueDtlsEntity?.qualityParameter}
                                                        </TableCell>
                                                        <TableCell align="center">{issueDetails.qualityIssueDtlsEntity?.measurementLocation} </TableCell>
                                                        <TableCell align="center">{issueDetails.qualityIssueDtlsEntity?.measuringInstrument} </TableCell>
                                                        <TableCell align="center">{issueDetails.qualityIssueDtlsEntity?.measured_quantity} </TableCell>
                                                        <TableCell align="center">{issueDetails.qualityIssueDtlsEntity?.recordedQuantity} </TableCell>
                                                        <TableCell align="center">{issueDetails.qualityIssueDtlsEntity?.toleranceLimit} </TableCell>
                                                        <TableCell align='center'>{fDate(issueDetails.qualityIssueDtlsEntity?.updatedOn, 'dd/MM/yyyy')}</TableCell>
                                                        <TableCell align='center'>{issueDetails.qualityIssueDtlsEntity?.updtdBy}</TableCell>
                                                    </TableRow>
                                                    {/* ))} */}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Scrollbar>
                                </Card>
                            </Grid>
                        </Grid>

                        <Grid container>
                            <Grid item xs={12}>
                                <Card sx={{ p: 2 }}>
                                    <Typography variant="h5" component="h3">
                                        Review & Approval Report
                                    </Typography>
                                    <TextField
                                        sx={{ mt: 2, me: 2 }}
                                        id="filled-disabled"
                                        variant="filled"
                                        label="Action taken closure report"
                                        placeholder="Type text here"
                                        style={{ width: '40%' }}
                                        multiline
                                        rows={4}
                                        disabled
                                        value={issueDetails.qualityIssueDtlsEntity?.actionTakenClosureReport || ""}
                                    />
                                    <TextField
                                        sx={{ mt: 2, float: right }}
                                        id="outlined-textarea"
                                        label="Review & Approve Comment"
                                        placeholder="Type text here"
                                        style={{ width: '55%' }}
                                        multiline
                                        rows={4}
                                        value={updateReport}
                                        onChange={updateReportHandler}
                                        inputProps={{
                                            maxLength: 500
                                        }}
                                    />
                                </Card>
                            </Grid>
                        </Grid>
                        <Box sx={{ paddingLeft: '3%' }} >
                            <Grid item xs={12} sm={6} md={6}>
                                {selectedFiles.map((file, index) => (
                                    <Stack direction="row">
                                        📁
                                        &nbsp;
                                        <Typography color="neutral" > {file?.documentName}
                                            &nbsp;
                                            &nbsp;

                                            <RemoveRedEyeIcon color="primary" onClick={() => downloadDocument(file, "Create")} variant="outlined" size="sm" />

                                        </Typography>

                                    </Stack>
                                ))
                                }
                            </Grid>
                        </Box>
                        <Stack style={{ display: 'inline-block' }}>
                            <Button variant="contained" size="medium" color="primary" startIcon={<ApproveIcon />} style={{ float: 'right' }} onClick={approveBtn}>Approve</Button>
                            {/* <Button variant="contained" size="medium" color="error" endIcon={<ThumbDownAltIcon />} style={{ float: 'right', marginRight: '20px' }} onClick={rejectBtn}>Reject</Button> */}
                            <Button variant="contained" size="medium" startIcon={<ReportIcon />} style={{ float: 'right', marginRight: '20px' }} onClick={clarifyBtn} disabled={Clarification}>Clarification</Button>
                        </Stack>
                    </Stack>
                </Card>
            </Container>
        </>
    )
}

export default IssueATCReview